import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Article extends Component {

  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { className } = this.props;
    return (
      <article className={`${className}`} >
        {this.props.children}
      </article>
    );
  }
}




// WEBPACK FOOTER //
// ./src/common/components/Article/Article.js